import { render, staticRenderFns } from "./Aduaneros.vue?vue&type=template&id=52431f70&"
import script from "./Aduaneros.vue?vue&type=script&lang=js&"
export * from "./Aduaneros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports